(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const sheet = root.querySelector('.mp-use-sheet');
    const title = sheet.querySelector('h3');
    const tags = sheet.querySelector('.mp-use-sheet__tags');
    const text = sheet.querySelector('p');
    const icon = sheet.querySelector('.mp-use-sheet__icon');
    const close = () => { sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('mp-use-sheet-lock'); };
    root.querySelectorAll('.mp-use-picker__row button').forEach((button) => button.addEventListener('click', () => {
      title.textContent = button.dataset.useTitle;
      text.textContent = button.dataset.useText;
      tags.replaceChildren(...button.dataset.useTags.split('|').map((label) => { const span=document.createElement('span'); span.textContent=label; return span; }));
      icon.innerHTML = button.querySelector('svg').outerHTML;
      sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden','false'); document.documentElement.classList.add('mp-use-sheet-lock');
    }));
    sheet.querySelectorAll('[data-use-close]').forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  };
  const initAll=()=>document.querySelectorAll('[data-mp-use-picker]').forEach(init);
  initAll(); document.addEventListener('DOMContentLoaded',initAll); document.addEventListener('shopify:section:load',initAll);
})();
